import { render, staticRenderFns } from "./AIChatBot.vue?vue&type=template&id=7452571a&scoped=true&"
import script from "./AIChatBot.vue?vue&type=script&lang=js&"
export * from "./AIChatBot.vue?vue&type=script&lang=js&"
import style0 from "./AIChatBot.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AIChatBot.vue?vue&type=style&index=1&id=7452571a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7452571a",
  null
  
)

export default component.exports